export const theme = {
  colors: {
    primary: '#0058FF',
    onPrimary: '#FFFFFF',
    secondary: '#1FD59B',
    onSecondary: '#FFFFFF',
    terciary: '#001357',
    onTerciary: '#FFFFFF',
    surface: '#FFFFFF',
    onSurface: '#231D19',
    background: '#F4F7FC',
    onBackground: '#231D19',
    backdrop: 'rgba(0, 0, 0, 0.35)',
    disabledBackground: '#E6E9F4',
    onDisabledBackground: '#5A607F',
    danger: '#E53E3E',
    onDanger: '#FFFFFF',
    warning: '#DD6B20',
    onWarning: '#FFFFFF',
    success: '#38A169',
    onSuccess: '#FFFFFF',
    info: '#36CEED',
    onInfo: '#FFFFFF',
    purple: '#7E3FF2',
    onPurple: '#FFFFFF',
    darkGray: '#999999',
    lightGray: '#DDDDDD',
    phone: '#F03260',
    email: '#1A2C4D',
    whatsapp: '#25D366',
    sms: '#36CEED',
    yellow: '#ffeb81',
    gray: {
      600: '#28272C',
      300: '#757575',
      200: '#a8a8b3',
      100: '#DDDDDD',
      50: '#f5f5f5',
    },
    charts: {
      1: '#c2dffa',
      2: '#98ccf6',
      3: '#6ab2f0',
      4: '#4794eb',
      5: '#3176dd',
      6: '#2862cc',
      7: '#274fa5',
      8: '#254683',
      9: '#162b50',
      10: '#0b1528',
    },
  },
  boxShadow: {
    sm: '0px 1px 4px #15223214',
    md: '3px 3px 15px #00000044',
  },
  spacing: {
    xxs: '4px',
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xlg: '64px',
    none: '0px',
  },
  borderRadius: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '12px',
  },
  breakpoints: {
    laptop: '1440px',
    tablet: '850px',
    mobile: '375px',
  },
};
